export default __webpack_public_path__ + "static/media/GabayGuro.57cb6fdc.png";